const containerTrailers = [
  {
    "model": "10FT Container Trailer",
    "cargo_dimensions": "300 X 244 X 68 CM",
    "total_length": "450 CM",
    "axles": "2 X AS 1350 KG",
    "maximum_authorized_mass": "3500 KG",
    "own_mass": "1180 KG",
    "loading_capacity": "2320 KG",
    "price": 4450,
    "newPrice": null,
    "img": "images/container-trailers-2025/10FT.jpg",
    "imgAlt": "container trailer"
  },
  {
    "model": "10FT Container Trailer",
    "cargo_dimensions": "300 X 244 X 68 CM",
    "total_length": "450 CM",
    "axles": "2 X AS 1800 KG",
    "maximum_authorized_mass": "3500 KG",
    "own_mass": "450 KG",
    "loading_capacity": "3050 KG",
    "price": 4750,
    "newPrice": null,
    "img": "images/container-trailers-2025/10FT.jpg",
    "imgAlt": "container trailer"
  },
  {
    "model": "20FT Container Trailer",
    "cargo_dimensions": "600 X 244 X 68 CM",
    "total_length": "750 CM",
    "axles": "2 X AS 1800 KG",
    "maximum_authorized_mass": "3500 KG",
    "own_mass": "560 KG",
    "loading_capacity": "2940 KG",
    "price": 5050,
    "newPrice": null,
    "img": "images/container-trailers-2025/20FT.jpg",
    "imgAlt": "container trailer"
  },
  {
    "model": "20FT Container Trailer",
    "cargo_dimensions": "600 X 244 X 68 CM",
    "total_length": "750 CM",
    "axles": "3 X AS 1350 KG",
    "maximum_authorized_mass": "3500 KG",
    "own_mass": "600 KG",
    "loading_capacity": "2900 KG",
    "price": 5450,
    "newPrice": null,
    "img": "images/container-trailers-2025/20FT 3 axles.jpg",
    "imgAlt": "container trailer"
  },
  {
    "model": "20FT Container Trailer",
    "cargo_dimensions": "600 X 244 X 68 CM",
    "total_length": "750 CM",
    "axles": "3 X AS 1800 KG",
    "maximum_authorized_mass": "3500 KG",
    "own_mass": "690 KG",
    "loading_capacity": "2810 KG",
    "price": 5750,
    "newPrice": null,
    "img": "images/container-trailers-2025/20FT 3 axles.jpg",
    "imgAlt": "container trailer"
  }
];


export default containerTrailers;
